export default class ComplexFilter {
  constructor(conjunction, filters) {
    this.conjunction = conjunction;
    this.filters = filters;
  }

  negated() {
    const conjunction = this.conjunction === 'and' ? 'or' : 'and';

    const negatedFilters = this.filters
      .map(filter => filter.negated());

    return new ComplexFilter(conjunction, negatedFilters);
  }

  toWhere() {
    const mappedFilters = this.filters
      .map(filter => filter.toWhere());

    return {
      [this.conjunction]: mappedFilters,
    };
  }
}
